import FILTER_PRINT_LABELS from "../../resources/filter-print-labels.js";
import React from "react";

const BOOLEAN_FILTER_FIELDS = new Set(["isHomeless", "indHasOccurrence", "hasSos", "hasEncounter", "hasBos", "alcoholDrugDependency", "mentalDisorder"]);

const hasPrintableFilterValue = (field, value) => {
    if (BOOLEAN_FILTER_FIELDS.has(field)) return value === true || value === "true";
    if (value === null || value === undefined) return false;
    if (typeof value === "string") return value.trim() !== "";
    if (Array.isArray(value)) return value.length > 0;

    return true;
}

const formatPrintableFilterValue = (field, value) => {
    if (value === null || value === undefined) return "";

    if (BOOLEAN_FILTER_FIELDS.has(field)) {
        if (value === true || value === "true") return "Sim";
        if (value === false || value === "false") return "Não";
    }

    if (Array.isArray(value)) return value.map(item => formatPrintableFilterValue(field, item)).join(", ");
    if (typeof value === "object") return value.label ?? value.value ?? "";

    return String(value).trim();
}

const getPrintableFilters = (filter) => {
    return Object.entries(FILTER_PRINT_LABELS).reduce((filters, [field, label]) => {
        const value = filter[field];
        if (!hasPrintableFilterValue(field, value)) return filters;

        filters.push({
            field,
            label,
            value: formatPrintableFilterValue(field, value),
        });

        return filters;
    }, []);
}

const PrintFilters = ({filter}) => {
    const printableFilters = getPrintableFilters(filter);

    return (
        <>
            <div id="filters-print" className={'transform !-translate-y-[8.5px]'}>
                {printableFilters.map(({field, label, value}) => (
                    <span key={field} className="filter-item pr-2"><b>{label}:</b> {value}</span>
                ))}
            </div>
            <div className="print:border-b print:border-gray-200 print:mb-6 print:w-full"/>
        </>
    );
}

export default PrintFilters;
